<template>
<div class="page3-container">
    <Step2Desktop ref="desktopStep2" @leavebuilder="leaveBuilder" @changepage="changePage($event)" @gostep="goStep($event)" v-if="!isMobile()"></Step2Desktop>
    <Step2Mobile ref="mobileStep2" @leavebuilder="leaveBuilder" @changepage="changePage($event)" v-else/>
</div>
</template>

<script>
import Step2Desktop from './Step2Desktop.vue';
import Step2Mobile from './Step2Mobile/Step2Mobile.vue';
export default {
    components: {
        Step2Desktop,
        Step2Mobile
    },
    data() {
        return{
        }
    },
    computed: {
    },
    methods: {
        isMobile() {
            return window.innerWidth < 768;
        },
        changePage(increment){
            this.$emit("changepage", increment);
        },
        leaveBuilder(){
            this.$emit("leavebuilder");
        },
        goStep(step){
            this.$emit("gostep",step);
        },
        showSort(){
            if(this.$refs.desktopStep2)
                this.$refs.desktopStep2.showSort();
            if(this.$refs.mobileStep2)
                this.$refs.mobileStep2.showSort();
        },
        showFilters(){
            if(this.$refs.desktopStep2)
                this.$refs.desktopStep2.showFilters();
            if(this.$refs.mobileStep2)
                this.$refs.mobileStep2.showFilters();
        }
    }
}
</script>

<style scoped>

.page3-container{
    width: 100%;
    display: flex;
}

@media screen and (max-width: 768px) {
    .page3-container{
        width: 100%;
        height: fit-content;
    }
}

</style>